import { useEffect, useState } from 'react';

/**
 * Versão nova da aplicação pronta a entrar. Numa caixa o separador quase
 * nunca fecha, por isso a versão nova não entra sozinha: o operador carrega
 * em "Actualizar" quando não tem venda a meio (a página recarrega).
 */
export function useUpdateReady(): (() => void) | null {
  const [waiting, setWaiting] = useState<ServiceWorker | null>(null);
  useEffect(() => {
    const on = (e: Event) => setWaiting((e as CustomEvent<ServiceWorker>).detail);
    addEventListener('pos-update-ready', on);
    return () => removeEventListener('pos-update-ready', on);
  }, []);
  return waiting ? () => waiting.postMessage('skip-waiting') : null;
}
